

const Counter = () => {
  return (
    <div className="container mx-auto py-5">
      <div className="justify-center text-center">
        <div className="w-full mb-12" data-aos="fade" data-aos-delay="100">
          <div className="text-3xl lg:text-4xl font-bold">1500+</div>
          <div className="text-sm leading-tight text-gray-400 mt-1 md:mt-5">Holidays Booked</div>
        </div>
        <div className="w-full mb-12" data-aos="fade" data-aos-delay="200">
          <div className="text-3xl lg:text-4xl font-bold">15+</div>
          <div className="text-sm leading-tight text-gray-400 mt-1 md:mt-5">Destinations</div>
        </div>
        <div className="w-full" data-aos="fade" data-aos-delay="300">
          <div className="text-3xl lg:text-4xl font-bold">1250+</div>
          <div className="text-sm leading-tight text-gray-400 mt-1 md:mt-5">Happy Customers</div>
        </div>
      </div>
    </div>
  );
};

export default Counter;
